import { render, staticRenderFns } from "./tp.vue?vue&type=template&id=17b74d27&scoped=true"
import script from "./tp.vue?vue&type=script&lang=js"
export * from "./tp.vue?vue&type=script&lang=js"
import style0 from "./tp.vue?vue&type=style&index=0&id=17b74d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b74d27",
  null
  
)

export default component.exports